import { parseEther, Address } from 'viem'
import { useAccount } from 'wagmi'
import useSWR from 'swr'
import { LidoSDKWrap } from '@lidofinance/lido-ethereum-sdk'
import { useLidoSDK, useGasFeeUSD } from '.'
import { FALLBACK_UNWRAP_GAS_LIMIT, ESTIMATE_ACCOUNT } from '../constants'
import { useDebounce } from '~/hooks/useDebounce'

const fetchUnwrapGasLimit = async (
  wrap: LidoSDKWrap,
  value: bigint,
  account: Address,
) => {
  return await wrap.unwrapEstimateGas({
    value,
    account,
  })
}

export const useUnwrapGasFee = (amount: string) => {
  const { address: userAccount } = useAccount()
  const account = (userAccount ?? ESTIMATE_ACCOUNT) as Address
  const { wrap } = useLidoSDK()
  const debouncedAmount = useDebounce(amount || '0.01', 500)
  const formattedAmount = parseEther(debouncedAmount)
  const { data } = useSWR(
    ['lido-unwrap-gas-limit', formattedAmount, account],
    () => fetchUnwrapGasLimit(wrap, formattedAmount, account),
    {
      refreshInterval: 60000,
    },
  )

  const gasLimit = data ?? FALLBACK_UNWRAP_GAS_LIMIT

  const { gasFee, gasFeeUSD } = useGasFeeUSD(gasLimit)

  return { gasLimit, gasFee, gasFeeUSD }
}
